<template>
	<layout-page-v2 class="health-reports" icon="health report" :h1="$t('base.watch.healthreports')">
		<div slot="btn-group" class="btn-group">
			<button-icon-text-loading @click.native="openModal({ action: 'add' })" icon="plus-w" class="plus btn-add">{{ $t('buttons.actions.add_healthreport') }}</button-icon-text-loading>
			<button-icon-text-loading v-if="selected" @click.native="openModal({ action: 'edit', id: selected.id })" icon="edit">{{ $t('buttons.actions.edit_healthreport') }}</button-icon-text-loading>
			<button-icon-text-loading v-if="selected" @click.native="deleteReport(selected.id)" :loading="loading.delete.has(selected.id)" icon="trash" class="btn-delete">{{ $t('buttons.actions.delete_healthreport') }}</button-icon-text-loading>
		</div>
		<spinner v-if="reports.loading" class="spinner"/>
		<div v-if="!reports.loading" class="side">
			<div v-if="!reports.loading && reports.data.length" class="side-reports">
				<div class="side-search">
					<input-text v-model="searchString" name="search" placeholder="Search"/>
				</div>
				<router-link
					v-for="report in filteredReports"
					:key="report.id"
					:to="{ name: 'WatchHealthReportsView', params: { user_uid: user_uid, watch_id: watch_id, report_id: report.id } }"
					class="side-report"
					exact-active-class="side-report-active">
					<svgicon name="health report" :fill="false" class="icon"/>
					<span>{{ report.name }}</span>
				</router-link>
			</div>
			<p v-if="!reports.loading && !filteredReports.length">No reports found</p>
		</div>
		<div v-if="!reports.loading" class="main" :class="{ empty: !selected }">
			<router-view v-model="selected" class="router-view"/>
			<p v-if="isBaseRoute">{{ $t('base.general.please_select') }}</p>
		</div>
		<health-report-form v-if="modalBox.open" @close="closeModal" :params="modalBox.params" :user_uid="user_uid" :watch_id="watch_id"/>
	</layout-page-v2>
</template>

<script>
import { debounce } from 'debounce'
import Fuse from 'fuse.js'
import HealthReport from './HealthReport'
import HealthReportForm from './HealthReportForm'
export default {
	components: {
		HealthReport,
		HealthReportForm
	},
	props: [
		'user_uid',
		'watch_id'
	],
	data () {
		return {
			loading: {
				delete: new Set()
			},
			reports: {
				loading: false,
				error: null,
				data: []
			},
			selected: null,
			// search
			searchString: '',
			fuseSearchString: '',
			debouncedFilterReports: null,
			// fuse.js options
			options: {
				shouldSort: true,
				threshold: 0.6,
				location: 0,
				distance: 100,
				maxPatternLength: 32,
				minMatchCharLength: 1,
				keys: [
					"name"
				]
			},
			fuse: null,
			modalBox: {
				open: false,
				params: {}
			}
		}
	},
	computed: {
		filteredReports () {
			//this.$log.info('watch healthreports', 'filteredReports', this.fuseSearchString)()
			return (this.fuse && this.fuseSearchString) ? this.fuse.search(this.fuseSearchString) : this.reports.data
		},
		isBaseRoute () {
			return this.$route.name === 'WatchHealthReports'
		}
	},
	watch: {
		'$route' (to, from) {
			if (to.name === 'WatchHealthReports') {
				this.selected = null
			}
		},
		searchString () {
			this.debouncedFilterReports()
		}
	},
	methods: {
		getReports () {
			this.selected = null
			this.reports.loading = true
			this.$api.healthreports.getAll(this, this.user_uid, this.watch_id)
				.then(response => {
					this.$log.info('watch healthreports', 'healthreports.getAll OK', response)()
					this.reports.data = response.body
					this.fuse = new Fuse(this.reports.data, this.options)
				}).catch(error => {
					this.$log.error('watch healthreports', 'healthreports.getAll ERROR', error)()
					this.reports.error = error
				}).finally(() => {
					this.reports.loading = false
				})
		},
		deleteReport (id) {
			if (confirm('Delete?')) {
				this.loading.delete.add(id)
				this.$forceUpdate()
				this.$api.healthreports.delete(this, this.user_uid, this.watch_id, id)
					.then(response => {
						this.$log.info('watch healthreports', 'healthreports.delete OK', response)()
						this.$router.push({ name: 'WatchHealthReports', params: { user_uid: this.user_uid, watch_id: this.watch_id } })
						this.getReports()
					}).catch(error => {
						this.$log.error('watch healthreports', 'healthreports.delete ERROR', error)()
					}).finally(() => {
						this.loading.delete.delete(id)
					})
			}
		},
		filterReports () {
			this.fuseSearchString = this.searchString
		},
		openModal (params = {}) {
			this.modalBox.open = true
			this.modalBox.params = params
		},
		closeModal (params) {
			this.modalBox.open = false
			this.modalBox.params = {}

			if (params.reload) {
				this.getReports()
			}
		}
	},
	beforeUpdate () {
		this.$title('Health Reports')
	},
	created () {
		this.debouncedFilterReports = debounce(this.filterReports, 200)
		this.getReports()
	}
}
</script>



// WEBPACK FOOTER //
// src/components/watch/healthreports/HealthReports.vue